import { render, staticRenderFns } from "./EditSurveyConfirmation.vue?vue&type=template&id=eddd830c&scoped=true"
import script from "./EditSurveyConfirmation.vue?vue&type=script&lang=js"
export * from "./EditSurveyConfirmation.vue?vue&type=script&lang=js"
import style0 from "./EditSurveyConfirmation.vue?vue&type=style&index=0&id=eddd830c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddd830c",
  null
  
)

export default component.exports